<template>
  <div>
    <div class="page flex ai-s">
      <div class="leftBox">
        <div class="prediction" v-if="detailInfo != null">
          <div class="predictionBox flex flex-align-center">
            <div class="title">Results</div>
            <ul class="flex list"  v-if="detailInfo.wdlDetail.hasOwnProperty('baseInfo')">
              <li>
                <div class="topBox" :class="`${detailInfo.wdlDetail.baseInfo.hasOwnProperty('winRecommend') ? 'active' : ''} ${detailInfo.wdlDetail.baseInfo.hasOwnProperty('winRecommend') && detailInfo.wdlDetail.baseInfo.hasOwnProperty('hit') && detailInfo.wdlDetail.baseInfo.hit == 1 ? 'hit' : ''}` ">WIN</div>
                <div class="bottomBox">
                  <!-- <div class="odds">HOME（{{detailInfo.wdlDetail.baseInfo.win}}）</div> -->
                  <div class="odds">HOME（{{ oddsCallFn(1, detailInfo.wdlDetail.baseInfo.win, 'home') }}）</div>
                  
                </div>
              </li>
              <li>
                <div class="topBox" :class="`${detailInfo.wdlDetail.baseInfo.hasOwnProperty('drawRecommend') ? 'active' : ''} ${detailInfo.wdlDetail.baseInfo.hasOwnProperty('drawRecommend') && detailInfo.wdlDetail.baseInfo.hasOwnProperty('hit') && detailInfo.wdlDetail.baseInfo.hit == 1 ? 'hit' : ''}` ">WIN</div>
                <div class="bottomBox">
                  <!-- <div class="odds">DRAW（{{detailInfo.wdlDetail.baseInfo.draw}}）</div> -->
                  <div class="odds">DRAW（{{ oddsCallFn(1, detailInfo.wdlDetail.baseInfo.draw, 'draw') }}）</div>
                </div>
              </li>
              <li>
                <div class="topBox" :class="`${detailInfo.wdlDetail.baseInfo.hasOwnProperty('lossRecommend') ? 'active' : ''} ${detailInfo.wdlDetail.baseInfo.hasOwnProperty('lossRecommend') && detailInfo.wdlDetail.baseInfo.hasOwnProperty('hit') && detailInfo.wdlDetail.baseInfo.hit == 1 ? 'hit' : ''}` ">WIN</div>
                <div class="bottomBox">
                  <!-- <div class="odds">AWAY（{{detailInfo.wdlDetail.baseInfo.loss}}）</div> -->
                  <div class="odds">AWAY（{{ oddsCallFn(1, detailInfo.wdlDetail.baseInfo.loss, 'away') }}）</div>
                </div>
              </li>
            </ul>
          </div>
          <div class="flex">
            <div class="confidencebox flex flex-align-center">
              <div>Confidence Index</div>
              <div class="star" :class="'star'+(detailInfo.wdlDetail.confidence * 2)"  v-if="detailInfo.wdlDetail.hasOwnProperty('confidence')">
                <i></i>
                <i></i>
                <i></i>
                <i></i>
                <i></i>
              </div>
            </div>
            <div class="updateTime flex flex-align-center" @click="pupHistoryShow = !pupHistoryShow">
              {{getGameTime(detailInfo.wdlDetail.updateTime,'dd MM ,HH:mm')}}  Updated 
              <i class="icon"></i>
            </div>
          </div>
        </div>

        <div v-if="detailInfo != null">
          <div v-if="isLogin == true || match.state == 4">
            <!-- 指数走势 -->
            <div class="oddsTrend">
              <div class="flex flex-pack-justify flex-align-center">
                <div class="title">Odds Trend</div>
                <ul class="radio flex flex-align-center">
                  <li @click="changeType(1)" :class="isDay == 1 ? 'active' : ''">Date</li>
                  <li @click="changeType(0)" :class="isDay == 0 ? 'active' : ''" v-if="detailInfo.wdlDetail.oddsTrend.time.length > 0">24H</li>
                </ul>
              </div>
              <div class="oddsTrendBox">
                <div class="container">
                  <div class="flex flex-pack-justify flex-align-center">
                    <div class="tip">
                      Initial  
                      <span class="home">{{ oddsCallFn(1, detailInfo.wdlDetail.oddsTrend[isDay == 1 ? 'day' : 'time'][0].home, 'home') }}</span> | 
                      <span class="draw">{{ oddsCallFn(1, detailInfo.wdlDetail.oddsTrend[isDay == 1 ? 'day' : 'time'][0].draw, 'draw') }}</span> | 
                      <span class="away">{{oddsCallFn(1, detailInfo.wdlDetail.oddsTrend[isDay == 1 ? 'day' : 'time'][0].away, 'away')}}</span>
                    </div>
                    <div class="tip">Live 
                      <span class="home">{{oddsCallFn(1, detailInfo.wdlDetail.oddsTrend[isDay == 1 ? 'day' : 'time'][detailInfo.wdlDetail.oddsTrend[isDay == 1 ? 'day' : 'time'].length-1].home, 'home')}}</span> | 
                      <span class="draw">{{oddsCallFn(1, detailInfo.wdlDetail.oddsTrend[isDay == 1 ? 'day' : 'time'][detailInfo.wdlDetail.oddsTrend[isDay == 1 ? 'day' : 'time'].length-1].draw, 'draw')}}</span> | 
                      <span class="away">{{oddsCallFn(1, detailInfo.wdlDetail.oddsTrend[isDay == 1 ? 'day' : 'time'][detailInfo.wdlDetail.oddsTrend[isDay == 1 ? 'day' : 'time'].length-1].away, 'away')}}</span>
                    </div>
                  </div>
                  <div ref="lineEchart" class="lineEchart"></div>
                </div>
                <div class="flex wdl flex-pack-center">
                  <div class="win">Home</div>
                  <div class="draw">Draw</div>
                  <div class="lose">Away</div>
                </div>
              </div>
            </div>

            <!-- 指数公司升降统计（99家） -->
            <div class="liftStatistics">
              <div class="flex flex-pack-justify flex-align-center">
                <div class="title">The stats of {{detailInfo.wdlDetail.companyOddsStat.companyCount}} bookmakers</div>
                <div class="rds flex">
                  <div class="rise">Up</div>
                  <div class="drop">Down</div>
                  <div class="stable">Stay</div>
                </div>
              </div>
              <div class="liftStatisticsBox">
                <div class="container">
                  <div class="flex echartList" v-if="detailInfo.wdlDetail.hasOwnProperty('companyOddsStat')">
                    <div class="pieChart" ref="liftStatistics_chart1"></div>
                    <div class="pieChart" ref="liftStatistics_chart2"></div>
                    <div class="pieChart" ref="liftStatistics_chart3"></div>
                  </div>
                  <div v-if="detailInfo.wdlDetail.hasOwnProperty('companyOddsStat')">
                    <div class="flex liftStatisticsLine_rise">
                      <div class="flex1" :class="getMaxNum('up') == detailInfo.wdlDetail.companyOddsStat.home.up ? 'active' : ''">{{getOddsStat(1,1)}}% Up</div>
                      <div class="flex1" :class="getMaxNum('up') == detailInfo.wdlDetail.companyOddsStat.draw.up ? 'active' : ''">{{getOddsStat(2,1)}}% Up</div>
                      <div class="flex1" :class="getMaxNum('up') == detailInfo.wdlDetail.companyOddsStat.away.up ? 'active' : ''">{{getOddsStat(3,1)}}% Up</div>
                    </div>
                    <div class="flex liftStatisticsLine_drop">
                      <div class="flex1" :class="getMaxNum('down') == detailInfo.wdlDetail.companyOddsStat.home.down ? 'active' : ''">{{getOddsStat(1,2)}}% Down</div>
                      <div class="flex1" :class="getMaxNum('down') == detailInfo.wdlDetail.companyOddsStat.draw.down ? 'active' : ''">{{getOddsStat(2,2)}}% Down</div>
                      <div class="flex1" :class="getMaxNum('down') == detailInfo.wdlDetail.companyOddsStat.away.down ? 'active' : ''">{{getOddsStat(3,2)}}% Down</div>
                    </div>
                    <div class="flex liftStatisticsLine_stable">
                      <div class="flex1" :class="getMaxNum('flat') == detailInfo.wdlDetail.companyOddsStat.home.flat ? 'active' : ''">{{getOddsStat(1,3)}}% Stay</div>
                      <div class="flex1" :class="getMaxNum('flat') == detailInfo.wdlDetail.companyOddsStat.draw.flat ? 'active' : ''">{{getOddsStat(2,3)}}% Stay</div>
                      <div class="flex1" :class="getMaxNum('flat') == detailInfo.wdlDetail.companyOddsStat.away.flat ? 'active' : ''">{{getOddsStat(3,3)}}% Stay</div>
                    </div>
                  </div>
                </div>
                <div class="tip">Note: Down' indicates an increase in hit probability, while 'Up' indicates a decrease in hit probability.</div>
              </div>
            </div>

            <!-- 历史交锋 -->
            <div class="historyClash" v-if="detailInfo.wdlDetail.matchLog.list.length > 0">
            <!-- <div class="historyClash" > -->
              <div class="title">Head-to-Head Records</div>
              <div class="historyClashBox">
                <div class="container"  v-if="detailInfo.wdlDetail.hasOwnProperty('matchLog')">
                  <div class="flex flex-align-center flex-pack-center relative">
                    <div class="pieChart" ref="historyClash_chart"></div>
                    <ul class="pct ">
                      <li class="winPct">{{getMatchNum('win')}} Win( {{detailInfo.wdlDetail.matchLog.win + '%'}} )</li>
                      <li class="drawPct">{{getMatchNum('draw')}} Draw( {{detailInfo.wdlDetail.matchLog.draw + '%'}} )</li>
                      <li class="lossPct">{{getMatchNum('loss')}} Loss( {{detailInfo.wdlDetail.matchLog.loss + '%'}} )</li>
                    </ul>

                    <!-- <ul class="flex iconLine">
                      <li class="win">胜</li>
                      <li class="draw">平</li>
                      <li class="lose">负</li>
                    </ul> -->
                  </div>
                  <ul class="matchList" :class="isDown == false ? '' : 'showAll'">
                    <li class="flex flex-align-center" v-for="(item,index) in detailInfo.wdlDetail.matchLog.list" :key="index" >
                      <div class="flex">
                        <div class="league">{{item.leagueName}}</div>
                        <div>{{getMatchTime(Math.floor(new Date(item.time).getTime() / 1000),'dd/MM YYYY')}}</div>
                      </div>
                      <div class="flex flex-align-center">
                        <div class="teamName txt-r" :class="(item.score.split('-')[0] > item.score.split('-')[1] ? 'state_win' : '')">{{getTeamName(item.homeId)}}</div>
                        <div class="score"><span :class="(item.score.split('-')[0] > item.score.split('-')[1] ? 'state_win' : '')">{{item.score.split('-')[0]}}</span>:<span :class="(item.score.split('-')[0] < item.score.split('-')[1] ? 'state_win' : '')">{{item.score.split('-')[1]}}</span></div>
                        <div class="teamName" :class="(item.score.split('-')[0] < item.score.split('-')[1] ? 'state_win' : '')">{{getTeamName(item.awayId)}}</div>
                      </div>
                      <div class="state" :class="getState(item.res,'class')">{{getState(item.res,'title')}}</div>
                    </li>
                  </ul>
                  <div class="down" @click="down()" v-show="isDown == false">
                    <i class="downIcon"></i>
                  </div>
                </div>
                <div class="tip">Note: Win, Draw, and Loss are based on the home team's performance in this matchup.</div>
              </div>
            </div>

            <!-- 历史同指数 -->
            <div class="historySameOdds" v-if="detailInfo.wdlDetail.hasOwnProperty('sameOddsHistory') && Object.keys(detailInfo.wdlDetail.sameOddsHistory.home).length != 0">
              <div class="title">Historical Performance for Similar Odds</div>
              <div class="historySameOddsBox">
                <div class="container">
                  <div class="subtext">Initial:</div>
                  <ul class="flex">
                    <li class="flex1">
                      <div class="win">
                        <div class="name">1</div> 
                        <div>{{oddsCallFn(1, detailInfo.wdlDetail.sameOddsHistory.home.odds, 'home')}}</div>
                      </div>
                      <!-- oddsCallFn(2, detailInfo.wdlDetail.sameOddsHistory.away.odds, 'away') -->
                      <div class="pieChart" ref="sameOdds_chart1"></div>
                      <div class="winTitle">{{detailInfo.wdlDetail.sameOddsHistory.home.hitCount}} home wins</div>
                    </li>
                    <li class="flex1">
                      <div class="draw">
                        <div class="name">X</div>  
                        <div>{{oddsCallFn(1, detailInfo.wdlDetail.sameOddsHistory.draw.odds, 'draw')}}</div>
                      </div>
                      <div class="pieChart" ref="sameOdds_chart2"></div>
                      <div class="drawTitle">{{detailInfo.wdlDetail.sameOddsHistory.draw.hitCount}} draws</div>
                    </li>
                    <li class="flex1">
                      <div class="lose">
                        <div class="name">2</div>  
                        <div>{{oddsCallFn(1, detailInfo.wdlDetail.sameOddsHistory.away.odds, 'away')}}</div>
                      </div>
                      <div class="pieChart" ref="sameOdds_chart3"></div>
                      <div class="loseTitle">{{detailInfo.wdlDetail.sameOddsHistory.away.hitCount}} away wins</div>
                    </li>
                  </ul>
                </div>
                <div class="tip">Note: The probabilities represent the likelihood of each outcome based on historical matches with similar initial odds.</div>
              </div>
            </div>

            <div style="clear: both"></div>
          </div>
          <div class="noLogin" v-if="isLogin == false && match.state != 4">
            <!-- <img src="../../../assets/images/noLogin_Bg2.png"> -->
            <div class="noLoginBox">
              <i class="noLoginIcon"></i>
              <p>Log in to view the content.</p>
              <div class="btn" @click="onChangePop({loginShow:true, loginInfoShow:false})">Log in Now</div>
            </div>
          </div>
        </div>
        <div v-else class="noData">
          <div><img src="../../../assets/images/nodata.png" /></div>
          <div class="title">No data</div>
        </div>
        
        
      </div>

      <div class="rightBox flex1">
      <div class="title">Additional Matches</div>
      <ul class="list">
        <li v-for="(item,index) in relateMatch" :key="index" @click="changeMatch(item)">
          <div class="flex flex-align-center">
            <div class="logo"><img :src="common.teamImgGet(item['homeTeam']['id'])" @error="common.imgError($event, 'team')"  alt=""></div>
            <div class="name">{{ item.homeTeam.fullName }}</div>
          </div>
          <div class="flex flex-align-center">
            <div class="logo"><img :src="common.teamImgGet(item['awayTeam']['id'])" @error="common.imgError($event, 'team')"  alt=""></div>
            <div class="name">{{ item.awayTeam.fullName }}</div>
          </div>
          <div class="league flex flex-align-center">
            <div class="logo"><img :src="common.leagueImgGet(item['leagueId'])" @error="common.imgError($event, 'team')"  alt=""></div>
            <div class="name">{{relateLeague[item.leagueId]['shortName']}}  {{getGameTime(item.startTime, 'dd MM YYYY,HH:mm')}}</div>
          </div>
        </li>
      </ul>
    </div>
    </div>

    <van-popup class="popup" v-model="pupHistoryShow" :position="isWeb?'center':'bottom'" round  get-container="#app" >
      <div class="popup_head flex flex-align-center">
        <p class="popup_title">Historical recommended records</p>
        <i class="popup_close" @click="pupHistoryShow = !pupHistoryShow"/>
      </div>
      <div class="popup_body">
        <ul class="popup_body_head flex">
          <li>Updated Time</li>
          <li>1</li>
          <li>x</li>
          <li>2</li>
        </ul>
        <ul class="list" v-if="logList != null">
          <li class="flex" v-for="(item,index) in logList.slice().reverse()" :key="index">
            
            <div v-if="isWeb">{{getMatchTime(item.updateTime,'YYYY.MM.dd HH:mm')}}</div>
            <div v-if="!isWeb">{{getMatchTime(item.updateTime,'YYYY.MM.dd')}}<br />{{getMatchTime(item.updateTime,'HH:mm')}}</div>
            <div :class="item.value[3] == 1 ? 'active' : ''">{{oddsCallFn(1, item.value[0], 'home')}}</div>
            <div :class="item.value[3] == 2 ? 'active' : ''">{{oddsCallFn(1, item.value[1], 'draw')}}</div>
            <div :class="item.value[3] == 3 ? 'active' : ''">{{oddsCallFn(1, item.value[2], 'away')}}</div>
          </li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>

<script>
import * as echarts from "echarts"


export default {
  data(){
    return {
      isDay: 1, //指数走势 1:天，0：24H
      pupHistoryShow:false,
      lineEachart: '',
      isWeb: true,
      isDown: false,
      loginShow: false,
    }
  },
  props: {
    detailInfo: {
      type: Object,
      default:null
    }, 
    logList: {
      type: Array,
      default:null
    }, 
    relateMatch: {
      type: Array,
      default:null
    },
    relateLeague: {
      type: [Object,Array],
      default:null
    },
    isLogin: {
      type: Boolean,
      default:false
    },
    setting: {
      type: Object,
      default: () => {}
    },
    match: {
      type: Object,
      default:null
    }, 
  },
  methods:{
    changeType(val){
      this.isDay = val
      this.getLineInfo()
    },
    getState(res,type){
      // let home = socer.split('-')[0]
      // let away = socer.split('-')[1]
      // if(home > away){
      //   return (type == 'class' ? 'state_1' : 'W')
      // }else if(home < away){
      //   return (type == 'class' ? 'state_3' : 'L')
      // }else{
      //   return (type == 'class' ? 'state_2' : 'D')
      // }
      if(res == 3){
        return (type == 'class' ? 'state_3' : 'L')
      }else if(res == 2){
        return (type == 'class' ? 'state_2' : 'D')
      }else{
        return (type == 'class' ? 'state_1' : 'W')
      }
    },
    // 获取百分比
    percentageVal(a,b,num){
      if(a && b){
        return (((b/a) * 100).toFixed(num) || 0) + '%'
      }else{
        return '0%'
      }
    },
    // 历史交锋图表数据处理
    getHistoryClashChart(){
      if(this.detailInfo.wdlDetail.hasOwnProperty('matchLog') == false || !this.$refs.historyClash_chart){
        return
      }
      let val = {
        win: this.detailInfo.wdlDetail.matchLog.win,
        draw: this.detailInfo.wdlDetail.matchLog.draw,
        loss: this.detailInfo.wdlDetail.matchLog.loss
      }
      let obj = {
        isShowTitle: false,
        title: '',
        winColor: '#09B363',
        drawColor: '#8C8C8C',
        lossColor: '#EB3420',

      }
      this.pieChart1('historyClash_chart',val,obj)
    },
    // 指数公司升降统计图表数据处理
    getLiftStatisticsChart(){
      if(this.detailInfo.hasOwnProperty('wdlDetail') == false || this.detailInfo.wdlDetail.hasOwnProperty('companyOddsStat') == false){
        return
      }
      let val1 = {
        win: this.detailInfo.wdlDetail.companyOddsStat.home.up,
        draw: this.detailInfo.wdlDetail.companyOddsStat.home.flat,
        loss: this.detailInfo.wdlDetail.companyOddsStat.home.down
      }
      let obj1 = {
        isShowTitle: true,
        title: '1',
        winColor: '#E90C69',
        drawColor: '#8C8C8C',
        lossColor: '#414C9F',

      }
      
      this.pieChart1('liftStatistics_chart1',val1,obj1)

      let val2 = {
        win: this.detailInfo.wdlDetail.companyOddsStat.draw.up,
        draw: this.detailInfo.wdlDetail.companyOddsStat.draw.flat,
        loss: this.detailInfo.wdlDetail.companyOddsStat.draw.down
      }
      let obj2 = {
        isShowTitle: true,
        title: 'X',
        winColor: '#E90C69',
        drawColor: '#8C8C8C',
        lossColor: '#414C9F',

      }
      this.pieChart1('liftStatistics_chart2',val2,obj2)

      let val3 = {
        win: this.detailInfo.wdlDetail.companyOddsStat.away.up,
        draw: this.detailInfo.wdlDetail.companyOddsStat.away.flat,
        loss: this.detailInfo.wdlDetail.companyOddsStat.away.down
      }
      let obj3 = {
        isShowTitle: true,
        title: '2',
        winColor: '#E90C69',
        drawColor: '#8C8C8C',
        lossColor: '#414C9F',

      }
      this.pieChart1('liftStatistics_chart3',val3,obj3)
    },
    // 比较值大小
    getMaxNum(type){
      if(type == 'up'){
        let home = this.detailInfo.wdlDetail.companyOddsStat.home.up
        let draw = this.detailInfo.wdlDetail.companyOddsStat.draw.up
        let away = this.detailInfo.wdlDetail.companyOddsStat.away.up
        return Math.max(home, draw, away)
      }else if(type == 'down'){
        let home = this.detailInfo.wdlDetail.companyOddsStat.home.down
        let draw = this.detailInfo.wdlDetail.companyOddsStat.draw.down
        let away = this.detailInfo.wdlDetail.companyOddsStat.away.down
        return Math.max(home, draw, away)
      }else if(type == 'flat'){
        let home = this.detailInfo.wdlDetail.companyOddsStat.home.flat
        let draw = this.detailInfo.wdlDetail.companyOddsStat.draw.flat
        let away = this.detailInfo.wdlDetail.companyOddsStat.away.flat
        return Math.max(home, draw, away)
      }
    },
    // 历史同指数图表数据处理
    getSameOddsHistoryChart(){
      if(this.detailInfo.wdlDetail.hasOwnProperty('sameOddsHistory') == false){
        return
      }
      let val1 = {
        val1: this.detailInfo.wdlDetail.sameOddsHistory.home.hitCount,
        val2: this.detailInfo.wdlDetail.sameOddsHistory.home.count,
      }
      let obj1 = {
        isShowTitle: true,
        title: this.percentageVal(this.detailInfo.wdlDetail.sameOddsHistory.home.count,this.detailInfo.wdlDetail.sameOddsHistory.home.hitCount,0),
        color1: '#09B363',
        color2: '#d9d9d9',
      }
      this.pieChart2('sameOdds_chart1',val1,obj1)

      let val2 = {
        val1: this.detailInfo.wdlDetail.sameOddsHistory.draw.hitCount,
        val2: this.detailInfo.wdlDetail.sameOddsHistory.draw.count,
      }
      let obj2 = {
        isShowTitle: true,
        title: this.percentageVal(this.detailInfo.wdlDetail.sameOddsHistory.draw.count,this.detailInfo.wdlDetail.sameOddsHistory.draw.hitCount,0),
        color1: '#8C8C8C',
        color2: '#d9d9d9',
      }
      this.pieChart2('sameOdds_chart2',val2,obj2)

      let val3 = {
        val1: this.detailInfo.wdlDetail.sameOddsHistory.away.hitCount,
        val2: this.detailInfo.wdlDetail.sameOddsHistory.away.count,
      }
      let obj3 = {
        isShowTitle: true,
        title: this.percentageVal(this.detailInfo.wdlDetail.sameOddsHistory.away.count,this.detailInfo.wdlDetail.sameOddsHistory.away.hitCount,0),
        color1: '#EB3420',
        color2: '#d9d9d9',
      }
      this.pieChart2('sameOdds_chart3',val3,obj3)
    },
    // 指数走势
    getLineInfo(){
      if(this.detailInfo == null){
        return
      }
      this.$nextTick(() =>{
        let homeArr = []
        let drawArr = []
        let awayArr = []
        let timeArr = []
        let arr = this.isDay == 1 ? this.detailInfo.wdlDetail.oddsTrend.day : this.detailInfo.wdlDetail.oddsTrend.time
        
        for (let i = 0; i < arr.length; i++) {
          const ele = arr[i];
          if(this.setting.oddsFormRadio == 2){
            homeArr.push(Number(eval(ele.home).toFixed(2)))
            drawArr.push(Number(eval(ele.draw).toFixed(2)))
            awayArr.push(Number(eval(ele.away).toFixed(2)))
          }else{
            homeArr.push(this.oddsCallFn(1, ele.home, 'home'))
            drawArr.push(this.oddsCallFn(1, ele.draw, 'draw'))
            awayArr.push(this.oddsCallFn(1, ele.away, 'away'))
          }
          // console.log(homeArr,drawArr,awayArr)
          let time = ele.createTime.replace(/-/g,"/").split('.')[0]
          
          if(this.isDay == 1){
            // timeArr.push(this.getEchartTime(Math.floor(new Date(ele.createTime).getTime() / 1000, 'dd')))
            timeArr.push(this.getMatchTime(Math.floor(new Date(time).getTime() / 1000),'dd'))
          }else{
            timeArr.push(this.getMatchTime(Math.floor(new Date(time).getTime() / 1000),'HH:mm'))
          }
          // alert(timeArr)
        }
        this.lineEchart = echarts.init(this.$refs.lineEchart);
        let _this = this
        this.lineEchart.setOption({
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '0%',
            right: '4%',
            bottom: '0%',
            top: '3%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(38, 38, 38, 0.8)',
            hideDelay: 800,
            borderWidth: 2,
            borderColor: '#595959',
            boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.3)',
            borderRadius: 5,
            textStyle: { // 提示框浮层的文本样式。
              color: '#fff',
              fontSize: 12,
            },
            padding: [14,32,14,12],
            confine: true,
            formatter: function(arg) {
              let ih = `<div style="font-weight: bold">${arg[0].name}${_this.isDay == 1 ? 'th' : ''}</div>`
              for (let i = 0; i < arg.length; i++) {
                const ele = arg[i];
                if(_this.setting.oddsFormRadio == 2){
                  ih += `<div>${ele.seriesName}: ${_this.oddsCallFn(1, ele.value, (i == 0 ? 'home' : i == 1 ? 'draw' : 'away'))}</div>`
                }else{
                  ih += `<div>${ele.seriesName}: ${ele.value}</div>`
                }
              }
              return ih
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: timeArr
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: 'Home',
              type: 'line',
              data: homeArr,
              smooth: true,
              symbolSize: 5,
              symbol: 'circle',
              itemStyle: {
                color: '#09B363'    //小圆点和线的颜色
              },
            },
            {
              name: 'Draw',
              type: 'line',
              data: drawArr,
              smooth: true,
              symbolSize: 5,
              symbol: 'circle',
              itemStyle: {
                color: '#8C8C8C'    //小圆点和线的颜色
              },
            },
            {
              name: 'Away',
              type: 'line',
              data: awayArr,
              smooth: true,
              symbolSize: 5,
              symbol: 'circle',
              itemStyle: {
                color: '#EB3420'    //小圆点和线的颜色
              },
            },
          ]
        });
        this.lineEchart.resize();
      })
    },
    pieChart1(dom,val,obj){
      var pieChart1 = echarts.init(this.$refs[dom]);
      pieChart1.setOption({ 
        tooltip: {
          trigger: 'none'  // 设置提示框触发方式为'none'，即不触发提示框
        },
        title: {
          text: obj.isShowTitle == false ? '' : obj.title,
          left: 'center', // 标题居中
          top: 'center',
          textStyle: {
            fontSize: 20, // 设置标题文字大小为20像素
            fontWeight: 'bold'
          }
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['60%', '100%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              disable:true,
              scale:false,
              scaleSize:0,
            },
            labelLine: {
              show: false
            },
            data: [
              { 
                value: val.loss, 
                name: '降',
                itemStyle: {
                  normal: {
                    //这里是颜色
                    color: obj.lossColor
                  }
                }
              },
              
              { 
                value: val.draw, 
                name: '稳',
                itemStyle: {
                  normal: {
                    //这里是颜色
                    color: obj.drawColor
                  }
                }
              },
              { 
                value: val.win, 
                name: '升',
                itemStyle: {
                  normal: {
                    //这里是颜色
                    color: obj.winColor
                  }
                }
              },
            ]
          }
        ]
      });
      pieChart1.resize();
    },

    pieChart2(dom,val,obj){
      var pieChart2 = echarts.init(this.$refs[dom]);
      pieChart2.setOption({
        tooltip: {
          trigger: 'none'  // 设置提示框触发方式为'none'，即不触发提示框
        },
        title: {
          text: obj.isShowTitle == false ? '' : obj.title,
          left: 'center', // 标题居中
          top: 'center',
          textStyle: {
            fontSize: this.isWeb == true ? 16 : 12 // 设置标题文字大小为20像素
          }
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['60%', '100%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              disable:true,
              scale:false,
              scaleSize:0,
            },
            labelLine: {
              show: false
            },
            data: [
              { 
                value: val.val1, 
                name: '降',
                itemStyle: {
                  normal: {
                    //这里是颜色
                    color: obj.color1
                  }
                }
              },
              { 
                value: val.val2, 
                name: '升',
                itemStyle: {
                  normal: {
                    //这里是颜色
                    color: obj.color2
                  }
                }
              },
            ]
          }
        ]
      });
      pieChart2.resize();
    },

    // 关联比赛
    changeMatch(item){
      let _homeName = this.common.formalTitle(this.match.homeTeam.fullName)
      let _awayName = this.common.formalTitle(this.match.awayTeam.fullName)
      if(this.$route.params.id != item.matchId) this.$router.push("/details/" +  this.$route.params.tab + '/' + item.matchId + '/' + _homeName + '-vs-' + _awayName);
    },

    getLiftStatisticsEchart(){
      this.$nextTick(() =>{
        if(this.detailInfo != null){
          this.getLiftStatisticsChart()
          this.getHistoryClashChart()
          this.getSameOddsHistoryChart()
        }
      })
    },
    
    // 历史交锋
    down(){
      this.isDown = true;
    },
    //获取屏幕宽度
    handleResize() {
      if(typeof window!='undefined'){
        this.isWeb=(window.innerWidth>767?true:false)
        if(this.lineEchart) this.lineEchart.resize()
        this.getLiftStatisticsEchart()
      }
    },

    getGameTime(startTime,_dateForm){
      var _tz = '+08:00'
      var _this=this;
      var setting=_this.common.getCookie('setting');  
      // var _dateForm = 'dd MM YYYY HH:mm';
    
      if(setting!=null&&setting!=undefined&&setting){
        setting=JSON.parse(setting);
        _tz=setting.tsz
      }

      var _time=this.common.dateStr(this.common.getDateByArray(_tz, startTime),_dateForm);
      
      var timeArr = _time.split(' ')
      timeArr[1] = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Spt","Oct","Nov","Dec"][timeArr[1]-1]
      _time = timeArr.join(' ')
      return _time;

    },
    
    // 获取更新时间
    getMatchTime(val,dateForm){
      let _val = val;
      let _tsz = this.setting.tsz;
      var setting=this.common.getCookie('setting');  
      // var _dateForm = 'dd MM YYYY HH:mm';
    
      if(setting!=null&&setting!=undefined&&setting){
        setting=JSON.parse(setting);
        _tsz=setting.tsz
      }

      let _time = this.common.getDateByArray(_tsz, _val);
      
      return this.common.dateStr(_time, dateForm);
    },

    // 指数返回
    oddsCallFn(ot, val, type){
      let _val = Number(val), _type = type;
      if(typeof(_val) == 'undefined'){
        return '-'
      }

      return this.oddsLuckyChange(ot, _val, _type);
    },

    // 赔率转换
    oddsLuckyChange(ot, val, type2){
      let _val = val, _form = this.setting.oddsFormRadio, _type = ot, _type2 = type2;
      let _typeArr = ['home', 'away', 'over', 'under'];

      // if(_type == 1){
      //   return this.common.oddsFromChange(_val, _form);
      // }

      if(_type == 2 || _type == 3){
        if(_typeArr.includes(_type2)){
          _val =  this.common.addValue(_val*1,1);
        }
      }
      if(_type2 == 'hand' || _type2 == 'total'){
        return _val;
      }

      return this.common.oddsFromChange(_val, _form);
    },

    // 获取球队名
    getTeamName(id){
      let match = this.detailInfo.match
      if(id == match.homeTeam.id){
        return match.homeTeam.shortName
      }else{
        return match.awayTeam.shortName
      }
    },
    // 获取场数
    getMatchNum(type){
      let winNum = 0
      let drawNum = 0
      let lossNum = 0
      for(let i = 0; i < this.detailInfo.wdlDetail.matchLog.list.length; i++){
        let item = this.detailInfo.wdlDetail.matchLog.list[i]
        if(item.res == 1) {winNum = winNum + 1}
        else if(item.res == 2) {drawNum = drawNum + 1}
        else if(item.res == 3) {lossNum = lossNum + 1}
      }
      
      if(type == 'win'){
        return winNum
      }else if(type == 'draw'){
        return drawNum
      }else if(type == 'loss'){
        return lossNum
      }
    },
    
    // 登录传参
    onChangePop(val) {
      let _val = val;
      this.$emit('onChangLogin', _val);
    },
    // 处理指数百分比
    getOddsStat(type,num){
      if(type == 1){
        let homeUp = Math.floor(this.detailInfo.wdlDetail.companyOddsStat.home.up)
        let homeDown = Math.floor(this.detailInfo.wdlDetail.companyOddsStat.home.down)
        let homeFlat = Math.floor(this.detailInfo.wdlDetail.companyOddsStat.home.flat)

        if((homeUp == 100 || homeDown == 100 || homeFlat == 100) || (homeUp == 0 && homeDown == 0 && homeFlat == 0)){
          return num == 1 ? homeUp : num == 2 ? homeDown : homeFlat
        }else{
          if(homeUp == 0 && homeDown != 0 && homeFlat != 0){
            homeFlat = 100 - homeDown
          }else if(homeUp != 0 && homeDown == 0 && homeFlat != 0){
            homeFlat = 100 - homeUp
          }else if(homeUp != 0 && homeDown != 0 && homeFlat == 0){
            homeDown = 100 - homeUp
          }else{
            homeFlat = 100 - homeUp - homeDown
          }
          return num == 1 ? homeUp : num == 2 ? homeDown : homeFlat
        }
      }else if(type == 2){
        let drawUp = Math.floor(this.detailInfo.wdlDetail.companyOddsStat.draw.up)
        let drawDown = Math.floor(this.detailInfo.wdlDetail.companyOddsStat.draw.down)
        let drawFlat = Math.floor(this.detailInfo.wdlDetail.companyOddsStat.draw.flat)

        if((drawUp == 100 || drawDown == 100 || drawFlat == 100) || (drawUp == 0 && drawDown == 0 && drawFlat == 0)){
          return num == 1 ? drawUp : num == 2 ? drawDown : drawFlat
        }else{
          if(drawUp == 0 && drawDown != 0 && drawFlat != 0){
            drawFlat = 100 - drawDown
          }else if(drawUp != 0 && drawDown == 0 && drawFlat != 0){
            drawFlat = 100 - drawUp
          }else if(drawUp != 0 && drawDown != 0 && drawFlat == 0){
            drawDown = 100 - drawUp
          }else{
            drawFlat = 100 - drawUp - drawDown
          }
          return num == 1 ? drawUp : num == 2 ? drawDown : drawFlat
        }
      }else if(type == 3){
        let awayUp = Math.floor(this.detailInfo.wdlDetail.companyOddsStat.away.up)
        let awayDown = Math.floor(this.detailInfo.wdlDetail.companyOddsStat.away.down)
        let awayFlat = Math.floor(this.detailInfo.wdlDetail.companyOddsStat.away.flat)

        if((awayUp == 100 || awayDown == 100 || awayFlat == 100) || (awayUp == 0 && awayDown == 0 && awayFlat == 0)){
          return num == 1 ? awayUp : num == 2 ? awayDown : awayFlat
        }else{
          if(awayUp == 0 && awayDown != 0 && awayFlat != 0){
            awayFlat = 100 - awayDown
          }else if(awayUp != 0 && awayDown == 0 && awayFlat != 0){
            awayFlat = 100 - awayUp
          }else if(awayUp != 0 && awayDown != 0 && awayFlat == 0){
            awayDown = 100 - awayUp
          }else{
            awayFlat = 100 - awayUp - awayDown
          }
          return num == 1 ? awayUp : num == 2 ? awayDown : awayFlat
        }
      }
    }
  },
  mounted() {
    
    setTimeout(() => {
      this.handleResize();
    },100)

    this.$nextTick(() => {
      if(typeof window!='undefined'){
        window.addEventListener('resize', this.handleResize);
      }
    })
  },
  beforeDestroy() {
    if(typeof window!='undefined'){
      window.removeEventListener('resize', this.handleResize);
    }
  },
  created() {
    // this.handleResize();
  },
  watch:{
    isLogin:{
      immediate: true,
      deep: true,
      handler(val) {
        if(val == true){
          this.getLineInfo()
          this.getLiftStatisticsEchart()
        }
      }
    },
    match:{
      immediate: true,
      deep: true,
      handler(val) {
        if(val.state == 4){
          this.getLineInfo()
          this.getLiftStatisticsEchart()
        }
      }
    },
    setting: {
      immediate: true,
      deep: true,
      handler(val) {
        if(this.isLogin == true || this.match.state == 4){
          this.getLineInfo()
        }
      }
    },
    detailInfo: {
      immediate: true,
      deep: true,
      handler(val) {
        if(this.isLogin == true || this.match.state == 4){
          this.getLineInfo()
          this.getLiftStatisticsEchart()
        }
      }
    }
  }
  
}
</script>
<style scoped lang="less"> 
  @import 'margin.less';  
</style>


// WEBPACK FOOTER //
// ./src/views/details/components/margin.vue